"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCache = exports.default = void 0;

var _md = _interopRequireDefault(require("md5"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _withProps = _interopRequireDefault(require("recompose/withProps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = []; // Memoized version of withProps from "recompose"
// Injects props to React component

var _default = function _default(component, props) {
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var hash = (0, _md.default)(JSON.stringify(props));
  var found = (0, _find2.default)(cache, {
    component: component,
    hash: hash
  });

  if (found) {
    return found.result;
  }

  var result = (0, _withProps.default)(props)(component);
  cache.push({
    component: component,
    hash: hash,
    result: result
  }); // Check the size of the cache

  if (cache.length > max) {
    cache.shift();
  }

  return result;
};

exports.default = _default;

var clearCache = function clearCache() {
  cache = [];
};

exports.clearCache = clearCache;